import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mobile-nav"
}
const _hoisted_2 = {
  key: 0,
  class: "mobile-nav-items"
}
const _hoisted_3 = {
  key: 0,
  class: "mobile-nav-badge"
}

import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useIsMobile } from '@/composables/useIsMobile';
import { useBottomBarInset } from '@/composables/useBottomBarInset';
import { navMenuItems, getActiveNavTab } from '@/utils/navigationMenu';
import NavToggle from '@/components/NavToggle.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileNavMenu',
  setup(__props) {

const isMobile = useIsMobile();
const route = useRoute();
const barInset = useBottomBarInset();

const isOpen = ref(false);

const menuItems = navMenuItems;

const activeTab = computed(() => getActiveNavTab(route.name));

// Close when navigating away by any other means (e.g. in-page links).
watch(
  () => route.fullPath,
  () => {
    isOpen.value = false;
  },
);

// The comparison bar's mobile height already includes the safe-area inset,
// so only add our own env() padding when sitting directly on the viewport edge.
const anchorBottom = computed(() =>
  barInset.value > 0 ? `${barInset.value + 7}px` : 'calc(11px + env(safe-area-inset-bottom, 0px))',
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_Transition, { name: "mobile-nav-fade" }, {
            default: _withCtx(() => [
              (isOpen.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "mobile-nav-backdrop",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false))
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "mobile-nav-anchor",
            style: _normalizeStyle({ bottom: anchorBottom.value })
          }, [
            _createVNode(_Transition, { name: "mobile-nav-pop" }, {
              default: _withCtx(() => [
                (isOpen.value)
                  ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems), (item) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          key: item.to.name,
                          to: item.to,
                          class: _normalizeClass(["mobile-nav-item", { 'mobile-nav-item--active': activeTab.value === item.to.name }]),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass([item.icon, "mobile-nav-item-icon"])
                            }, null, 2),
                            _createElementVNode("span", null, _toDisplayString(item.text), 1),
                            (item.beta)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "New!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["to", "class"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(NavToggle, {
              class: "mobile-nav-fab",
              shape: "circle",
              open: isOpen.value,
              onToggle: _cache[2] || (_cache[2] = ($event: any) => (isOpen.value = !isOpen.value))
            }, null, 8, ["open"])
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})